/**
 * Canonical NZ party configuration.
 * All other party-related lookups are derived from this single source.
 */
export const PARTIES = {
  nat:   { name: "National", shortLabel: "Nat",   color: "#0056A8", field: "nat_pred_n",   pastVoteField: "past_vote_nat"   },
  lab:   { name: "Labour",   shortLabel: "Lab",   color: "#E82C2C", field: "lab_pred_n",   pastVoteField: "past_vote_lab"   },
  act:   { name: "ACT",      shortLabel: "ACT",   color: "#FFD700", field: "act_pred_n",   pastVoteField: "past_vote_act"   },
  green: { name: "Green",    shortLabel: "Green", color: "#009639", field: "green_pred_n", pastVoteField: "past_vote_green" },
  nzf:   { name: "NZF",      shortLabel: "NZF",   color: "#000000", field: "nzf_pred_n",   pastVoteField: "past_vote_nzf"   },
  tpm:   { name: "TPM",      shortLabel: "TPM",   color: "#CC0033", field: "tpm_pred_n",   pastVoteField: "past_vote_tpm"   },
  oth:   { name: "Other",    shortLabel: "Oth",   color: "#999999", field: "oth_pred_n",   pastVoteField: "past_vote_oth"   },
};

/** Coalition colour — used wherever the right coalition is shown as a single entity */
export const COALITION_COLOR = "#1B4F8A";

/** { "nat_pred_n": { name, color }, ..., coalition: { name, color } } — for map/grid components */
export const PARTY_INFO = {
  ...Object.fromEntries(
    Object.values(PARTIES).map(({ name, color, field }) => [field, { name, color }])
  ),
  coalition: { name: "Coalition", color: COALITION_COLOR },
};

/** { nat: "#0056A8", ... } — for components using short keys */
export const PARTY_COLOURS = Object.fromEntries(
  Object.entries(PARTIES).map(([k, { color }]) => [k, color])
);

/** { National: "#0056A8", ... } — for components using display-name keys */
export const PARTY_COLOURS_BY_NAME = Object.fromEntries(
  Object.values(PARTIES).map(({ name, color }) => [name, color])
);

/** { National: "nat_pred_n", ... } — for VoteLineCharts / NationalVoteBar field lookups */
export const PARTY_FIELDS_BY_NAME = Object.fromEntries(
  Object.values(PARTIES).map(({ name, field }) => [name, field])
);

/** { "nat_pred_n": "past_vote_nat", ... } — for VotersSeats past-vote heat map */
export const PAST_VOTE_MAP = Object.fromEntries(
  Object.values(PARTIES).map(({ field, pastVoteField }) => [field, pastVoteField])
);

/** Ordered list for scatter/arrow comparison controls (excludes Other) */
export const COMPARE_PARTY_OPTIONS = Object.entries(PARTIES)
  .filter(([k]) => k !== "oth")
  .map(([, { shortLabel: label, color, field: key }]) => ({ key, label, color }));

/** Derive { labels, colors } maps from any PARTY_INFO-shaped object */
export function buildLabelsAndColors(info = PARTY_INFO) {
  const labels = {};
  const colors = {};
  Object.entries(info).forEach(([key, { name, color }]) => {
    labels[key] = name;
    colors[key] = color;
  });
  return { labels, colors };
}
